import React, { Component } from "react";
import "./create.css";
import Profile from "./profile";
import Input from "./input";
import stepsAll from "../assets/icon/stepsAll.png";

class Create extends Component {
  state = {};
  render() {
    return (
      <div className="create">
        <div className="container">
          <h1 className="Or-create-an-account"> Or, create an account</h1>
          <div className="row steps">
            <div className="col">
              <img src={stepsAll} alt="" align="left" className="img-fluid " />
            </div>
          </div>
          <div className="row paddd">
            <div className="col-6">
              <Profile />
            </div>
            <div className="col-xl">
              <Input />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Create;
